import { render, staticRenderFns } from "./productVersion.vue?vue&type=template&id=07e5029f&"
import script from "./productVersion.vue?vue&type=script&lang=js&"
export * from "./productVersion.vue?vue&type=script&lang=js&"
import style0 from "./productVersion.vue?vue&type=style&index=0&id=07e5029f&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports